/**
 * default-schemes — 공통 Zod 스키마 및 타입
 *
 * 기존 `packages/shared/api/default.schemes.ts`의 내용을 래퍼로 이동.
 * 외부 소비자가 import 경로만 변경하면 동작하도록 동일한 인터페이스를 제공한다.
 */
import z from "zod";
export const DefaultBasicInfoSchema = z
    .object({
    createdTime: z.string().datetime(),
    modifiedTime: z.string().datetime(),
    creater: z.coerce.number().nullable(),
    modifier: z.coerce.number().nullable(),
    deletedYn: z.number().int().min(0).max(1),
})
    .strict();
export const DefaultApprovalStatusSchema = z
    .object({
    approvalPhase: z.string(),
    creater: z.coerce.number(),
    createrId: z.string(),
    createrName: z.string(),
    createdTime: z.string().datetime(),
    modifier: z.coerce.number().optional(),
    modifiedTime: z.string().datetime().optional(),
    checker: z.coerce.number().nullable(),
    checkerId: z.string().nullable(),
    checkerName: z.string().nullable(),
    checkedDate: z.string().datetime().nullable(),
    approver: z.coerce.number().nullable(),
    approverId: z.string().nullable(),
    approverName: z.string().nullable(),
    approvedDate: z.string().datetime().nullable(),
    rejecter: z.coerce.number().nullable(),
    rejecterId: z.string().nullable(),
    rejecterName: z.string().nullable(),
    rejectedDate: z.string().datetime().nullable(),
    rejectReason: z.string().nullable(),
})
    .strict();
export const DefaultApprovalBodySchema = z
    .object({
    approvalPhase: z.string(),
    approver: z.coerce.number().nullable(),
    checker: z.coerce.number().nullable().optional(),
    purchaseManager: z.coerce.number().nullable().optional(),
    materialManager: z.coerce.number().nullable().optional(),
    rejecter: z.coerce.number().nullable(),
    rejectReason: z.string().nullable(),
})
    .strict();
export const MaterialManagerSchema = z
    .object({
    materialManager: z.coerce.number().nullable(),
    materialManagerId: z.string().nullable(),
    materialManagerName: z.string().nullable(),
})
    .strict();
export const PurchaseManagerSchema = z
    .object({
    purchaseManager: z.coerce.number().nullable(),
    purchaseManagerId: z.string().nullable(),
    purchaseManagerName: z.string().nullable(),
})
    .strict();
export const ProductImageSchema = z
    .object({
    id: z.coerce.number(),
    url: z.string(),
})
    .strict();
export const TotalStockInfoSchema = z
    .object({
    totalStock: z.coerce.number(),
    totalPrice: z.coerce.number().optional(),
    total: z.coerce.number(),
    limit: z.coerce.number(),
    page: z.coerce.number(),
    pageCount: z.coerce.number(),
})
    .strict();
export const UserInfoSchema = z
    .object({
    id: z.coerce.number(),
    userName: z.string(),
    givenName: z.string(),
    profileImageUrl: z.string().nullable(),
})
    .strict();
export const ProjectInfoSchema = z
    .object({
    id: z.coerce.number(),
    projectCode: z.string(),
    isPreOrder: z.coerce.number(),
})
    .strict();
export const CompanyInfoSchema = z
    .object({
    id: z.coerce.number(),
    name: z.string(),
})
    .strict();
export const ManagerInfoSchema = z
    .object({
    id: z.coerce.number(),
    name: z.string(),
    email: z.string(),
    phone: z.string(),
})
    .strict();
export const TempApprovalStatusSchema = z
    .object({
    _creater: UserInfoSchema,
    _checker: UserInfoSchema.nullable(),
    _approver: UserInfoSchema.nullable(),
    _rejecter: UserInfoSchema.nullable(),
    _project: ProjectInfoSchema.nullable(),
    _company: CompanyInfoSchema.nullable(),
    _manager: ManagerInfoSchema.nullable(),
})
    .strict();
